import {z} from 'zod';

export const InterestStateSchema = z.enum(['OPEN', 'NEW', 'CLOSED', 'UNSUCCESSFUL']);
export type InterestState = z.infer<typeof InterestStateSchema>;
